import { baseRoutes } from "helpers/baseRoutes";

const accessRoute = {
  LAYOUTTHREE: {
    path: `${baseRoutes.userBaseRoutes}layout-three`,
  },
};

export default accessRoute;
